import { render, staticRenderFns } from "./Authentica.vue?vue&type=template&id=7fe1b06a&scoped=true"
import script from "./Authentica.vue?vue&type=script&lang=js"
export * from "./Authentica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe1b06a",
  null
  
)

export default component.exports